import $ from 'jquery';
import Glider from 'glider-js';
import { MQ } from '../tools/MQ.js';
import debounce from 'lodash.debounce';

export const init = () => {
	let jsAbout, glider, initializedCarousel, initializedHoverEvent;
	initializedCarousel = false;
	initializedHoverEvent = false;

	const resizeGlider = function () {
		const w = screen.width;
		$('.glider-track').css('width', w * 4);
		$('.about-item').css('width', w);
	};

	const setHoverEvent = ($jsAbout) => {
		if (!initializedHoverEvent) {
			$jsAbout.find('.about__item').removeClass('about__item--active');
			$jsAbout.find('.about__item:first-child').addClass('about__item--active');
			$jsAbout.on('mouseenter', '.about__item', function () {
				$jsAbout.find('.about__item').removeClass('about__item--active');
				$(this).addClass('about__item--active');
			});
			initializedHoverEvent = true;
		}
	};

	const setAboutComponent = () => {
		jsAbout = document.querySelector('.js-about');

		if (jsAbout) {
			if (MQ('mdDown')) {
				if (initializedHoverEvent) {
					$(jsAbout).off('mouseenter', '.about__item');
					initializedHoverEvent = false;
				}
				if (!initializedCarousel) {
					glider = new Glider(jsAbout, {
						slidesToShow: 1,
						slidesToScroll: 1,
						draggable: true,
						dots: jsAbout.nextElementSibling,
						scrollLock: true,
						responsive: [
							{
								breakpoint: 750,
								settings: {
									dots: false,
									slidesToScroll: 'auto',
								},
							},
						],
					});
					jsAbout.addEventListener('glider-destroy', () => {
						jsAbout = document.querySelector('.js-about');
						setHoverEvent($(jsAbout));
					});
					initializedCarousel = true;
				}
			} else {
				if (initializedCarousel) {
					glider.destroy();
					initializedCarousel = false;
				} else {
					setHoverEvent($(jsAbout));
				}
			}
		}
	};
	setAboutComponent();
	$(window).on('resize', debounce(setAboutComponent, 200));

	if (['iPhone'].includes(navigator.platform)) {
		window.addEventListener('resizeGlider', resizeGlider, true);
	}
};
